import type { ReactNode } from 'react'

/*
  Badge — píldora de estado. Envuelve las clases `.badge` + `.badge-<variant>`
  definidas en src/styles/index.css (fuente única de estilos).
  Para un color nuevo: agregá una variante `.badge-<x>` al CSS, no estilos inline.
*/
export type BadgeVariant =
  | 'borrador' | 'publicado' | 'destacado' | 'producto'
  | 'activo' | 'info' | 'enviada' | 'aceptada' | 'rechazada'
  | 'cancelado' | 'completado' | 'pausado' | 'reprogramado'
  | 'ingreso' | 'egreso' | 'recurrente' | 'interno'
  // El semáforo. Las variantes de dominio de arriba se definen SOBRE estas en
  // index.css, no con un hex propio: cinco rojos distintos dejan de significar
  // «rojo».
  | 'success' | 'warning' | 'danger' | 'neutral'

interface BadgeProps {
  variant?: BadgeVariant
  children: ReactNode
}

export function Badge({ variant, children }: BadgeProps) {
  return <span className={`badge${variant ? ` badge-${variant}` : ''}`}>{children}</span>
}
